import {
  GET_GROUPS,
  ADD_GROUP,
  DELETE_GROUP,
  UPDATE_GROUP,
  GROUPS_LOADING
} from '../actions/types';

const initialState = {
  groups: [],
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_GROUPS:
      return { ...state, groups: action.payload, loading: false };
    case ADD_GROUP:
      return { ...state, groups: [action.payload, ...state.groups] };
    case UPDATE_GROUP:
      return {
        ...state,
        groups: state.groups.map(group =>
          group._id === action.payload._id ? action.payload : group
        )
      };
    case DELETE_GROUP:
      return {
        ...state,
        groups: state.groups.filter(group => group._id !== action.payload)
      };
    case GROUPS_LOADING:
      return { ...state, loading: true };
    default:
      return state;
  }
}
